import React from 'react';
import { Link } from 'react-router-dom';
import packageJson from '../../package.json';
import '../styles/Footer.css';

const APP_VERSION = packageJson.version;

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="footer-container">
        <div className="footer-links">
          <Link to="/changelog" className="footer-link">Changelog</Link>
          <Link to="/about" className="footer-link">About</Link>
          <Link to="/privacy" className="footer-link">Privacy</Link>
          <Link to="/terms" className="footer-link">Terms</Link>
        </div>
        <div className="footer-meta">
          <span className="footer-brand">Strat Guys</span>
          <span className="footer-copy">&copy; {currentYear}</span>
          <span className="footer-version">v{APP_VERSION}</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
